'use strict';

var angular = require('angular');
var TreeGridSettingsFactory = function TreeGridSettingsFactory($filter, fieldValidator, momentService, userPreferencesService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  return function (grid) {
    this.width = 700;
    this.height = 330;
    this.source = new angular.element.jqx.dataAdapter(grid.source);
    this.editable = true;
    this.showHeader = true;
    this.selectionMode = 'multiplerows';
    function createIdColumn() {
      return {
        dataField: 'id',
        hidden: true
      };
    }
    function createNameColumn(grid) {
      return {
        text: 'Selected Fields',
        dataField: 'name',
        width: 'auto',
        align: 'center',
        columnType: 'custom',
        createEditor: function createEditor(row, value, editor) {
          if (grid.isFieldRow(row)) {
            var inputElement = angular.element('<input/>').prependTo(editor);
            inputElement.jqxInput({
              width: '100%',
              height: '100%',
              source: [],
              disabled: true
            });
          } else {
            editor.jqxDropDownList({
              width: '100%',
              height: '100%',
              source: grid.logicOperators,
              selectedIndex: 0,
              //selectionMode: "dropDownList",
              autoDropDownHeight: true,
              displayMember: 'value',
              valueMember: 'value'
            });
          }
        },
        initEditor: function initEditor(row, cellvalue, editor) {
          if (grid.isFieldRow(row)) {
            var inputField = editor.find('input');
            inputField.jqxInput('val', cellvalue);
          } else {
            editor.jqxDropDownList('selectItem', cellvalue);
          }
        },
        getEditorValue: function getEditorValue(row, cellvalue, editor) {
          if (grid.isFieldRow(row)) {
            var inputField = editor.find('input');
            return inputField.jqxInput('val');
          } else {
            grid.searchById(row).name = editor.val();
            return editor.val();
          }
        }
      };
    }
    function createFiltersColumn(grid) {
      return {
        text: 'Operators',
        dataField: 'filterOperator',
        width: 100,
        align: 'center',
        columnType: 'custom',
        createEditor: function createEditor(row, value, editor) {
          if (grid.isFieldRow(row)) {
            var source = grid.searchById(row);
            editor.jqxDropDownList({
              source: source.availableFilters,
              autoDropDownHeight: true,
              width: '100%',
              height: '100%',
              displayMember: 'id',
              valueMember: 'id'
            });
          }
        },
        initEditor: function initEditor(row, cellvalue, editor) {
          editor.jqxDropDownList('selectItem', cellvalue);
        },
        getEditorValue: function getEditorValue(row, cellvalue, editor) {
          grid.searchById(row).filterOperator = editor.val();
          return editor.val();
        }
      };
    }
    function dateFormatToJqxWidgets(input) {
      input = input.replace(/YY/g, 'yy');
      input = input.replace(/DD/g, 'dd');
      return input;
    }
    function createInputColumn(grid) {
      return {
        text: 'Applied Filters',
        dataField: 'inputFilter',
        width: 'auto',
        align: 'center',
        columnType: 'custom',
        createEditor: function createEditor(row, value, editor) {
          if (grid.isDateRow(row)) {
            var dateElement = angular.element('<div/>').prependTo(editor);
            dateElement.jqxDateTimeInput({
              allowNullDate: false,
              formatString: dateFormatToJqxWidgets(userPreferencesService.getUserDateTimeSettings('dateFormat')),
              width: '100%',
              height: '100%',
              placeHolder: 'Select date'
            });
          } else if (grid.isFieldRow(row)) {
            var inputElement = angular.element('<input/>').prependTo(editor);
            inputElement.jqxInput({
              width: '100%',
              height: '100%',
              source: [],
              placeHolder: 'Value Type'
            });
          }
        },
        initEditor: function initEditor(row, cellvalue, editor) {
          if (grid.isDateRow(row)) {
            var dateField = editor.find('div');
            var now = momentService.systemNow(momentService.FIELD.DATA_EXTRACT_APPLIED_FILTERS).toISOString();
            dateField.jqxDateTimeInput('setDate', cellvalue || now);
          } else if (grid.isFieldRow(row)) {
            var inputField = editor.find('input');
            inputField.jqxInput('val', cellvalue);
          }
        },
        getEditorValue: function getEditorValue(row, cellvalue, editor) {
          if (grid.isDateRow(row)) {
            var dateField = editor.find('div');
            var dateObject = dateField.jqxDateTimeInput('getDate')[0][0][0][0][0];
            var filterMoment = momentService.of(dateObject, momentService.FIELD.DATA_EXTRACT_APPLIED_FILTERS);
            grid.searchById(row).inputFilter = filterMoment;
            return rmMomentFormat(filterMoment, 'DATE_USER_SETTINGS');
          } else if (grid.isFieldRow(row)) {
            var inputField = editor.find('input');
            grid.searchById(row).inputFilter = inputField.jqxInput('val');
            return inputField.jqxInput('val');
          } else {
            return '';
          }
        },
        validation: function validation(cell, value) {
          var field = grid.searchById(cell.row);
          return fieldValidator.validate(field, value);
        }
      };
    }
    this.columns = [createIdColumn(), createNameColumn(grid), createFiltersColumn(grid), createInputColumn(grid)];
  };
};
TreeGridSettingsFactory.$inject = ['$filter', 'TreeGridValidatorService', 'MomentService', 'UserPreferencesService'];
module.exports = TreeGridSettingsFactory;